/** 27.09 (владелец: «учёбка отображается как оплачиваемая доп-работа»): на главной кабинета
 *  учёбка ученика — своим жёлтым блоком, а не среди допработ. Ни денег, ни запроса времени,
 *  ни отчёта о такси; «Принял» — POST /accept (PUT confirmed для учёбки — это деньги). */
import { api } from "../../api/client";
import type { SideDuties } from "../../hooks/useOperatorDay";

type Css = Readonly<Record<string, string>>;

export function SideStudy({ items, css, onChanged }: { items: SideDuties["extras"]; css: Css; onChanged: () => void }) {
  if (!items.length) return null;
  return (
    <>
      <div className={`${css.secHead} ${css.studyHead}`}>
        <span className={css.ico}>🎓</span> Учёбка <span className={css.cnt}>({items.length})</span>
      </div>
      {items.map((e) => (
        <div key={e.id} className={`${css.dopCard} ${css.studyCard} ${e.accepted ? css.dopAcc : ""}`}>
          <div className={css.dopHeadRow}>
            <span className={css.dopTime}>{e.from}–{e.to}</span>
            {e.branch ? <span className={css.dopBranch}>{e.branch.toUpperCase()}</span> : null}
            {e.accepted ? <span className={css.dopSeen}>видел ✓</span> : (
              <button type="button" className={css.dopAcceptBtn}
                onClick={() => { void api(`/api/extra-work/${e.id}/accept`, { method: "POST" }).then(onChanged).catch(() => {}); }}>✓ Принял</button>
            )}
          </div>
          {e.desc ? <div className={css.dopDesc}>{e.desc}</div> : null}
          <div className={css.dopHint}>{e.curator ? `куратор ${e.curator} · ` : ""}без оплаты</div>
        </div>
      ))}
    </>
  );
}
